"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.ProductBoxTile = void 0;
var _extends2 = _interopRequireDefault(require("@babel/runtime/helpers/extends"));
var _react = _interopRequireDefault(require("react"));
var _EnergyLabel = require("b2b-components/core/components/EnergyLabel");
var _LabelList = require("b2b-components/theme/components/ProductList/ProductBox/common/LabelList");
var _StockCount = require("b2b-components/theme/components/StockCount");
var _device = require("b2b-components/utils/device");
var _getComponentDataAttributes = require("b2b-components/utils/getComponentDataAttributes");
var _classnames = _interopRequireDefault(require("classnames"));
var _Features = require("../common/Features");
var _ImageLink = require("../common/ImageLink");
var _Title = require("../common/Title");
var _Variants = require("../common/Variants");
const ProductBoxTile = _ref => {
  let {
    basePrice,
    category,
    className,
    imageUrl,
    manufacturerSku,
    onCategoryClick,
    onProductClick,
    price,
    sku,
    renderSku,
    stock,
    title,
    dataAttributes,
    deviceType = _device.DEVICE_TYPE.desktop,
    directDelivery = false,
    energyLabel = null,
    areVariantsHidden = false,
    isForSlider = false,
    isCoreAssortment = false,
    isOwnAssortment = false,
    isNew = false,
    isOccasion = false,
    isPromotion = false,
    isSellout = false,
    isSpecialOrder = false,
    isConsciousAlternative = false,
    renderActions = null,
    renderHiddenPrice = null,
    text = {
      sku: 'SKU',
      manufacturerSku: 'Manufacturer SKU',
      category: 'Category',
      variants: 'Also available in:',
      new: 'new',
      promotion: 'promotion',
      sellout: 'sellout',
      occasion: 'occasion',
      coreAssortment: 'Core Assortment',
      ownAssortment: 'Customer specific assortment',
      consciousAlternative: 'Conscious alternative',
      stockCount: {
        date: 'Date',
        deliveryDates: 'Expected delivery date',
        notReadyForShipment: 'Not ready for shipment',
        orderedQuantity: 'Ordered Quantity',
        readyForShipment: 'pc. ready for shipment',
        readyForDirectDelivery: 'pc. ready for direct delivery',
        unknownDeliveryDate: 'Unknown delivery date',
        specialOrder: {
          full: 'Special Order',
          short: 'S.O.',
          explanation: 'We do not stock this item.'
        },
        seeMore: 'see more',
        deliveryInfoPackage: 'This item ships in a separate package, directly from our supplier.',
        deliveryInfoTime: 'Delivery time is 3 to 5 business days.',
        directDeliveryStockInfo: 'stock in supplier’s warehouse'
      },
      bulkPrice: {
        buy: 'Buy',
        bulkPricing: 'Bulk pricing'
      }
    },
    url = '#',
    quantityOrdered = null,
    variantCount = 3,
    variants = [],
    bulkPrices
  } = _ref;
  const content = /*#__PURE__*/_react.default.createElement("div", (0, _extends2.default)({}, (0, _getComponentDataAttributes.getComponentDataAttributes)(dataAttributes), {
    className: (0, _classnames.default)('cds-ProductBox', className)
  }), /*#__PURE__*/_react.default.createElement("div", {
    className: "cds-ProductBox-TopWrapper"
  }, /*#__PURE__*/_react.default.createElement(_LabelList.LabelList, {
    isCoreAssortment: isCoreAssortment,
    isOwnAssortment: isOwnAssortment,
    isNew: isNew,
    isOccasion: isOccasion,
    isPromotion: isPromotion,
    isSellout: isSellout,
    isConsciousAlternative: isConsciousAlternative,
    text: text
  }), /*#__PURE__*/_react.default.createElement(_StockCount.StockCount, {
    deviceType: deviceType,
    quantityOrdered: quantityOrdered,
    isSpecialOrder: isSpecialOrder,
    stockCount: stock,
    text: text.stockCount,
    className: "cds-ProductBox-StockCount",
    directDelivery: directDelivery
  })), /*#__PURE__*/_react.default.createElement(_ImageLink.ImageLink, {
    imageUrl: imageUrl,
    onClick: onProductClick,
    title: title,
    url: url,
    sku: sku
  }), energyLabel && /*#__PURE__*/_react.default.createElement(_EnergyLabel.EnergyLabel, {
    range: energyLabel.range,
    rating: energyLabel.rating,
    energyLabelUrl: energyLabel.energyLabelUrl,
    text: energyLabel.text,
    size: _EnergyLabel.ENERGY_LABEL_SIZE.small,
    className: "cds-ProductBox-EnergyLabel"
  }), /*#__PURE__*/_react.default.createElement(_Title.Title, {
    sku: sku,
    url: url,
    title: title,
    onClick: onProductClick
  }), /*#__PURE__*/_react.default.createElement(_Features.Features, {
    basePrice: basePrice,
    category: category,
    renderHiddenPrice: renderHiddenPrice,
    manufacturerSku: manufacturerSku,
    onCategoryClick: onCategoryClick,
    price: price,
    renderActions: renderActions,
    sku: sku,
    renderSku: renderSku,
    text: text,
    bulkPrices: bulkPrices || [],
    bulkPriceTexts: text.bulkPrice
  }), areVariantsHidden ? null : /*#__PURE__*/_react.default.createElement(_Variants.Variants, {
    onProductClick: onProductClick,
    text: text,
    url: url,
    variantCount: variantCount,
    variants: variants
  }));
  return isForSlider ? content : /*#__PURE__*/_react.default.createElement("li", {
    className: "cds-ProductBoxWrapper"
  }, content);
};
exports.ProductBoxTile = ProductBoxTile;
//# sourceMappingURL=ProductBoxTile.js.map